import script from "./aboutView.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutView.vue?vue&type=script&setup=true&lang=js"

import "./aboutView.vue?vue&type=style&index=0&id=c1bd41f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1bd41f6"]])

export default __exports__